import ClickEventTrigger from 'components/ClickEventTrigger';
import * as React from 'react';
import { MouseEventHandler } from 'types/typescript/eventHandlers';

/**
 * ## Renders content inside of a tab.
 * ### See [Tabs](/internal/components/Tabs) for usage.
 */

class TabPanel extends React.Component<{
  className?: string;
  disableActivationOnClick?: boolean;
  hidden?: boolean;
  /** Tab button text */
  title: React.ReactNode;
  children?: React.ReactNode;
  eventElementName?: string;

  // HTML Element Props
  to?: string;
  indicator?: boolean;
  dataTestSelector?: string;
  eventProperties?: Object;
  eventKey?: string
  onClick?: MouseEventHandler;
}> {
  render() {
    const { eventElementName, children, className } = this.props;

    return (
      <ClickEventTrigger
        eventKey={this.props.eventKey}
        eventProperties={this.props.eventProperties}
        eventElementName={eventElementName}>
        <div className={className}>{children}</div>
      </ClickEventTrigger>
    );
  }
}

export default TabPanel;
